export default "__VITE_ASSET__9c4e7105__"